import { useState } from "react";
import { BookOpen, ChevronDown, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TAFSIR_FOOTER, useApi } from "@/lib/api";

const FullGroup = ({ target, onClose }) => {
  const api = useApi();
  const [g, setG] = useState(null);
  const [loaded, setLoaded] = useState(null);
  if (target && loaded !== target) {
    setLoaded(target);
    setG(null);
    api("get", "/tafsir/group", null, { params: target }).then(setG).catch(() => setG({ error: true }));
  }
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="tafsir-full-dialog">
        <DialogHeader>
          <DialogTitle className="arabic-sm text-2xl text-q text-right pr-8 pl-8" lang="ar">{g?.nama_ar || "…"}</DialogTitle>
        </DialogHeader>
        {!g ? <Loader2 className="animate-spin text-q" /> : g.error ? <p>Huraian tidak ditemui.</p> : (
          <>
            <div className="font-mono-data text-xs text-mute">Surah {g.surah}, ayat {g.from}{g.to !== g.from ? `–${g.to}` : ""}</div>
            <div className="tafsir-text text-ink" lang="ar" dir="rtl">{g.text}</div>
            <p className="text-xs text-mute border-t border-line pt-3">{TAFSIR_FOOTER}</p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export const TafsirExcerpts = ({ ayatRef }) => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [target, setTarget] = useState(null);
  const toggle = async () => {
    setOpen(!open);
    if (!data) {
      try { setData(await api("get", "/tafsir/excerpts", null, { params: { surah: ayatRef.surah, from: ayatRef.from, to: ayatRef.to } })); }
      catch { setData([]); }
    }
  };
  return (
    <div className="rounded-xl border border-line" data-testid="tafsir-excerpts">
      <button onClick={toggle} className="w-full flex items-center justify-between gap-3 p-4 text-sm font-semibold text-ink" data-testid="tafsir-excerpts-toggle" aria-expanded={open}>
        <span className="inline-flex items-center gap-2"><BookOpen size={16} className="text-q" /> Baca petikan tafsir asal (8 kitab)</span>
        <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-6">
          {!data ? <Loader2 className="animate-spin text-q" /> : data.map((t) => (
            <div key={t.key} className="border-t border-line pt-4" data-testid={`tafsir-block-${t.key}`}>
              <div className="arabic-sm text-xl text-q text-right" lang="ar">{t.nama_ar}</div>
              {t.items.length === 0 ? <p className="text-sm text-mute mt-2">Tiada huraian bagi ayat ini dalam set data.</p> :
                t.items.map((it) => (
                  <div key={it.ayah} className="mt-3">
                    <div className="font-mono-data text-[11px] text-mute">Ayat {it.ayah}{it.group_from !== it.group_to ? ` · huraian berkumpulan ${it.group_from}–${it.group_to}` : ""}</div>
                    <div className="tafsir-text text-ink/90 mt-1" lang="ar" dir="rtl">{it.excerpt}</div>
                    <button onClick={() => setTarget({ key: t.key, surah: ayatRef.surah, ayah: it.ayah })} data-testid={`tafsir-read-full-${t.key}-${it.ayah}`}
                      className="text-xs text-q underline underline-offset-4 mt-1">Baca huraian penuh</button>
                  </div>
                ))}
            </div>
          ))}
          <p className="text-xs text-mute border-t border-line pt-3" data-testid="tafsir-footer">{TAFSIR_FOOTER}</p>
        </div>
      )}
      <FullGroup target={target} onClose={() => setTarget(null)} />
    </div>
  );
};
